import { languageFallback, localeFallback } from '../assets/locale'

export function findLocaleFallback(language, country) {
  const locale = `${language}_${country}`
  if (localeFallback[locale]) {
    return localeFallback[locale]
  }
  return languageFallback[language] ? languageFallback[language] : 'en_US'
}
